<script>
import { nextTick } from 'vue'

import MessageBox from './common/MessageBox.vue'

import apiConfiguration from '@/api/api-configuration';

export default {
    name: 'SettingsImportComponent',

    components: {
        MessageBox
    },

    props: {
        languageStrings: {
            type: Object,
            default: null
        }
    },

    emits: ['form-closed'],

    computed: {
        fileNames() {
            let names = ''
            this.files.forEach((file) => {
                if (names.length > 0) {
                    names = names + ', '
                }
                names = names + file.name
            })
            return names
        }
    },

    data() {
        return {
            files: [],
            showMessage: false,
            message: '',
            messageType: -1,
            showMessageButtons: true,
            configType: "1-1",
            messageFileStatus: ""
        }
    },

    async mounted() {
        await nextTick()
        document.getElementById('form').focus()
    },

    methods: {
        handleFormKeyDown(event) {
            if (event.key === 'Escape') {
                this.closeForm()
            }
        },
        closeForm() {
            this.$emit('form-closed')
        },
        openFileDialog() {
            this.$refs.fileInput.click()
        },
        async onFileInputChange() {
            this.files = []
            this.files.push(...this.$refs.fileInput.files)
            await this.uploadFiles()
        },
        async uploadFiles() {
            this.messageFileStatus = ""
            this.message = (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.fileimport005 != null ? this.languageStrings.ui.fileimport005 : 'Nahrávám soubory...')
                + "\n" + this.messageFileStatus
            this.messageType = 0
            this.showMessageButtons = false
            this.showMessage = true

            const files = this.files

            for (let i = 0; i < files.length; i++) {
                const formData = new FormData()
                formData.append("file", files[i])

                let result = await apiConfiguration.uploadFile(this.configType , files[i].name.slice(0, -5), formData)
                if (result.code === 0) {
                    this.messageFileStatus += "\n" + files[i].name + ": " + "OK"
                }
                else {
                    this.messageFileStatus += "\n" + files[i].name + ": " + (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.fileimport008 != null ? this.languageStrings.ui.fileimport008 : "Chyba")
                }
            }

            this.message = (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.fileimport006 != null ? this.languageStrings.ui.fileimport006 : 'Soubory nahrány')
                + "\n" + this.messageFileStatus
            this.showMessageButtons = true
        },
        async messageBoxClosed(type) {
            this.files = []
            this.$refs.fileInput.value = null

            switch (type) {
                case 1:
                    this.showMessage = false
                    this.closeForm()
                    return
                default:
                    this.showMessage = false
                    break
            }
            await nextTick()
            document.getElementById('form').focus()
        }
    }
}
</script>

<template>
    <div class="form">
        <div id="form" @keydown="handleFormKeyDown" tabindex="-1">
            <span class="title">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu027 != null ? languageStrings.ui.menu027 : 'Import konfigurace' }}</span>
            <img src="@/assets/images/x.svg" @click="closeForm()" />

            <div class="form-wrapper">
                <div class="form-content rows gap-10">
                    <div>
                        <span style="padding-right: 10px;">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.fileimport009 != null ? languageStrings.ui.fileimport009 : 'Typ konfigurace' }}</span>

                        <select v-model="configType">
                            <option value="1-1">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.fileimport010 != null ? languageStrings.ui.fileimport010 : 'Jazyky - Analýzy' }}</option>
                            <option value="1-2-1">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.fileimport011 != null ? languageStrings.ui.fileimport011 : 'Jazyky - E-maily - Objednávka' }}</option>
                            <option value="1-2-2">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.fileimport012 != null ? languageStrings.ui.fileimport012 : 'Jazyky - E-maily - Reset odkaz' }}</option>
                            <option value="1-2-3">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.fileimport013 != null ? languageStrings.ui.fileimport013 : 'Jazyky - E-maily - Reset hesla' }}</option>
                            <option value="1-2-4">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.fileimport014 != null ? languageStrings.ui.fileimport014 : 'Jazyky - E-maily - Vzorek' }}</option>
                            <option value="1-3">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.fileimport015 != null ? languageStrings.ui.fileimport015 : 'Jazyky - Kategorie událostí' }}</option>
                            <option value="1-4">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.fileimport016 != null ? languageStrings.ui.fileimport016 : 'Jazyky - Typy olejů' }}</option>
                            <option value="1-5">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.fileimport017 != null ? languageStrings.ui.fileimport017 : 'Jazyky - UI' }}</option>
                            <option value="2">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.fileimport018 != null ? languageStrings.ui.fileimport018 : 'Semafory' }}</option>
                            <option value="3">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.fileimport019 != null ? languageStrings.ui.fileimport019 : 'Senzory' }}</option>
                        </select>
                    </div>

                    <div class="file-input">
                        <input type="file" multiple name="fileInput" id="fileInput" @change="onFileInputChange" ref="fileInput" accept="*" />
                        <input type="text" v-bind:value="fileNames" readonly />
                        <button class="button-small" @click="openFileDialog">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.fileimport001 != null ? languageStrings.ui.fileimport001 : 'Zvolit soubory' }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <MessageBox v-if="showMessage" :text="message" @form-closed="messageBoxClosed" :type="messageType" :showButtons="showMessageButtons" />
</template>